/**
 * hide initial panel/reveal next
 */
export const showNextStep = (currentStep, fields = false) => {
	const nextStepId = currentStep.dataset.nextStep;
	const nextStep = determineNextStep(nextStepId);

	if (nextStep.constructor.name === 'URL') {
		window.location.href = nextStep;
	} else {
		if (fields.constructor.name === 'FormData') {
			updateNextStepFields(nextStep, fields);
		}

		if (currentStep) {
			currentStep.inert = true;
			nextStep.removeAttribute('inert');
		}
	}
};



const determineNextStep = (value) => {
	if (!value.startsWith('#')) {
		try {
			return new URL(value, window.location.href);
		} catch { }
	}

	return document.querySelector(value);
}



export const resetForm = (id = null) => {
	const allSteps = document.querySelectorAll('.slf-step');

	allSteps.forEach((step, i) => {
		if ((id !== null && step.id === id) || (id === null && i > 0)) {
			step.removeAttribute('inert');
		} else {
			step.inert = true;
		}
	})
}






// if we know something already, don't ask for it again.
// also, bring email over from first step
const updateNextStepFields = (nextStep, fields) => {
	const nextForm = nextStep?.querySelector('form');

	if (nextForm) {
		Array.from(fields).filter(field => field[1] !== '').forEach((field) => {
			const [key, fieldValue] = [...field];
			const inputElement = document.createElement('input');
			inputElement.type = 'hidden';
			inputElement.name = key;
			inputElement.value = fieldValue;

			if (nextForm) {
				nextForm.appendChild(inputElement);
			}
		});
	}

	return fields;
}



export const getQueryStringValue = (param) => {
	const params = new URLSearchParams(window.location.search);
	return params.get(param);
};





/**
 * replace email placeholder on activation page
 */
export const updateEmailPlaceholders = (str) => {
	const placeholders = document.querySelectorAll('[data-email]');
	const replacement = str || getQueryStringValue('email');

	if (!placeholders) {
		return false;
	}

	placeholders.forEach((placeholder) => {
		placeholder.textContent = replacement;
	});
};





/**
 * show/hide spinner
 */
export const toggleSpinner = (state, formElement) => {
	const el = formElement.querySelector('button .spinner');

	el.classList.toggle('lds-ring--active', (state === 'show'));

	if (state === 'show') {
		el.closest('button').disabled = true;
	}

	if (state === 'hide') {
		el.closest('button').removeAttribute('disabled');
	}
};





export const gtmPush = (event, eventParameters = {}) => {
	if (window.google_tag_manager) {
		window.dataLayer.push({
			event,
			...eventParameters,
		});
	}
};





export const showProductError = (errorMessage) => {
	const errorWrapper = document.getElementById('product-error');
	const existingErrors = errorWrapper.querySelectorAll('p') || [];
	const msgElement = document.createElement('p');

	existingErrors.forEach((errMsg) => {
		errMsg.remove();
	})

	msgElement.classList.add('slf__warning');

	msgElement.innerHTML = errorMessage;

	errorWrapper.append(msgElement);
}





export const getCookieValue = (name) => {
	const cookies = document.cookie.split(';');

	cookies.forEach((cookie) => {
		if (cookie.trim().startsWith(`${name}=`)) {
			return cookie.substring(name.length + 1);
		}
	});

	return '';
}





export const setCookie = (name, value, exp = false) => {
	const attributes = {
		path: '/',
		secure: true,
		sameSite: 'none',
		domain: 'sumologic.com',
	}
	let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

	if (exp instanceof Date) {
		attributes.expire = exp.toUTCString();
	}

	for (let attr in attributes) {
		updatedCookie += `;${attr}`

		if (attributes[attr] !== true) {
			updatedCookie += `=${attributes[attr]}`;
		}
	}

	document.cookie = updatedCookie;
}



export const getRegionUrl = (region) => {
	const url = document.querySelector(`meta[name="sumo:login:${region}"]`).content;

	return url;
}



export const removeProductError = (id) => {
	const els = document.querySelectorAll(`[id^="${id}"]`);

	[...els].forEach((element) => {
		element.remove();
	})
}



export const getErrorPrefix = (url) => {
	const endpoint = new URL(url);
	const lastSegment = endpoint.pathname.substring(endpoint.pathname.lastIndexOf('/') + 1);
	return `err-${lastSegment}`;
}
